import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type UpdateStationeryDraftProductMutationVariables = Types.Exact<{
  data: Types.UpdateStationeryDraftProductInput;
}>;

export type UpdateStationeryDraftProductMutation = {
  __typename?: 'Mutation';
  updateStationeryDraftProduct: {
    __typename?: 'StationeryDraft';
    id: string;
    format: Types.StationeryDraftFormat;
    priceConfigId?: string | null;
    cardJSON: any;
    product?: { __typename?: 'StationeryProduct'; id: string } | null;
  };
};

export const UpdateStationeryDraftProductDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateStationeryDraftProduct' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateStationeryDraftProductInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateStationeryDraftProduct' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceConfigId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cardJSON' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'product' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateStationeryDraftProductMutationFn = Apollo.MutationFunction<UpdateStationeryDraftProductMutation, UpdateStationeryDraftProductMutationVariables>;

/**
 * __useUpdateStationeryDraftProductMutation__
 *
 * To run a mutation, you first call `useUpdateStationeryDraftProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStationeryDraftProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStationeryDraftProductMutation, { data, loading, error }] = useUpdateStationeryDraftProductMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateStationeryDraftProductMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStationeryDraftProductMutation, UpdateStationeryDraftProductMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateStationeryDraftProductMutation, UpdateStationeryDraftProductMutationVariables>(UpdateStationeryDraftProductDocument, baseOptions);
}
export type UpdateStationeryDraftProductMutationHookResult = ReturnType<typeof useUpdateStationeryDraftProductMutation>;
export type UpdateStationeryDraftProductMutationResult = Apollo.MutationResult<UpdateStationeryDraftProductMutation>;
export type UpdateStationeryDraftProductMutationOptions = Apollo.BaseMutationOptions<UpdateStationeryDraftProductMutation, UpdateStationeryDraftProductMutationVariables>;
